import { Col } from "@zendeskgarden/react-grid";
import { Component } from "react";
import { Row } from "react-bootstrap";
import { LG as LGText, Span } from "@zendeskgarden/react-typography";
import { t } from "../../../../../../translations/translation.service";
import {
  Label,
  Hint,
  Range,
  Field,
  Textarea,
  Input,
  Message
} from "@zendeskgarden/react-forms";
import OpportunityService from "../../../../../../services/opportunity.service";
import { avaliacaoUsuario } from '../../../../../../model/user.model';
import { MainContainer } from './styles';
import { Datepicker } from "@zendeskgarden/react-datepickers";
import { AuthenticationService } from "../../../../../../services/auth.service";
import { dateHelper } from "../../../../../../util/date";
import { AnyAction, Dispatch, bindActionCreators } from "redux";
import { getValidateValue } from '../../../../../../actions';
import { connect } from "react-redux";

const dateFormatter = dateHelper("pt-BR");
type AvaliationState = {
  avaliation: {
    avaliacao: any;
    opportunity: any;
    user: any;
    conteudo: string;
    created: Date;
    _id: string | undefined;
    resultado: number;
  };
  criteria: any[];
};

class OpportunityCriterias extends Component<{
  opportunityId: string;
  userId: string | undefined;
  avaliacao?: any;
  dataAvaliationCriteria: any;
  editCriteria?: avaliacaoUsuario;
  getValidateValue: any;
  validateValue: boolean;
}, AvaliationState> { // <-- Adicione o tipo do estado aqui

  constructor(props: any) {
    super(props);
    this.handleChangeCriteria = this.handleChangeCriteria.bind(this);
    this.handleDate = this.handleDate.bind(this);

    // Inicialize o estado aqui
    this.state = {
      avaliation: {
        avaliacao: props.avaliacao || {},
        opportunity: undefined,
        user: AuthenticationService.getUser(),
        conteudo: "",
        created: new Date(),
        _id: props.userId,
        resultado: 0,
      },
      criteria: [],
    };
  }
async componentDidMount() {
  const { editCriteria, opportunityId, dataAvaliationCriteria } = this.props;

  if (editCriteria) {
    const avaliationCriteria = editCriteria.opportunity?.avaliationCriteria || [];
    const created = new Date(editCriteria.created);

    const updatedAvaliation = {
      avaliacao: {},
      opportunity: editCriteria.opportunity || {},
      user: AuthenticationService.getUser(),
      conteudo: editCriteria.conteudo || "",
      created,
      _id: editCriteria._id,
      resultado: editCriteria.resultado || 0,
    };

    this.setState({
      avaliation: updatedAvaliation,
      criteria: avaliationCriteria,
    }, () => {
      dataAvaliationCriteria(updatedAvaliation);
    });

  } else {
    const { data } = await OpportunityService.getOpportunityLiteKanban(opportunityId);
    const criterios = data?.criteriosMatch || [];
    const avaliationCriteria = this.setOpportunity(criterios);

    const opportunity = {
      id: opportunityId,
      avaliationCriteria,
    };

    this.setState((prevState) => {
      const updatedAvaliation = {
        ...prevState.avaliation,
        opportunity,
      };

      return {
        criteria: criterios,
        avaliation: updatedAvaliation,
      };
    }, () => {
      this.props.dataAvaliationCriteria(this.state.avaliation);
    });
  }
}

  handleDate(date: Date): void {
    this.setState((prevState) => {
      const updated = {
        ...prevState.avaliation,
        created: date,
      };
      this.props.dataAvaliationCriteria(updated);
      return { avaliation: updated };
    });
  }

  handleChangeCriteria(e: any) {
    const { name, value } = e.target;

    this.setState((prevState) => {
      const updated = {
        ...prevState.avaliation,
        [name]: value,
      };

      if (name !== "resultado") {
        const conteudoValido = updated.conteudo.length > 0;
        this.props.getValidateValue(!conteudoValido);
      }

      this.props.dataAvaliationCriteria(updated);
      return { avaliation: updated };
    });
  }

  setOpportunity(criteria: any[]): any[] {
    return criteria.map((item) => ({
      name: item.name || item.nome,
      peso: item.peso,
    }));
  }

  render() {
    const { validateValue } = this.props;
    const { avaliation } = this.state;

    return (
      <>
        {!this.props.editCriteria && (
          <Row className="mb-1">
            <Col textAlign="center">
              <Field>
                <LGText>
                  <Span isBold>Avaliação escolhida:</Span>{" "}
                  <Span>Parecer Comportamental</Span>{" "}
                </LGText>
              </Field>
            </Col>
          </Row>
        )}

        <MainContainer />

        <Field className="mb-4">
          <Label>{t("Data da avaliação")}</Label>
          <Datepicker
            value={avaliation.created}
            onChange={this.handleDate}
            formatDate={(date) => dateFormatter.format(date)}
            isCompact
          >
            <Input isCompact />
          </Datepicker>
        </Field>

        <Field className="mb-4">
          <Label>Nota</Label>
          <Hint>
            O usuário tem nota {avaliation.resultado} nessa avaliação.
          </Hint>
          <Range
            step={1}
            max={10}
            value={avaliation.resultado}
            name="resultado"
            onChange={this.handleChangeCriteria}
          />
        </Field>

        <Field>
          <Label>Avaliação</Label>
          <Textarea
            value={avaliation.conteudo}
            onChange={this.handleChangeCriteria}
            name="conteudo"
            minRows={2}
            maxRows={12}
            validation={
              validateValue && avaliation.conteudo.length < 1
                ? "error"
                : undefined
            }
          />
          {validateValue && avaliation.conteudo.length < 1 && (
            <Message validation="error">
              {t("Preencha o campo Avaliação")}
            </Message>
          )}
        </Field>
      </>
    );
  }
}

const mapStateToProps = (store: {
  parecerComportamentalReducer: { validateValue: boolean };
}) => ({
  validateValue: store.parecerComportamentalReducer.validateValue,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      getValidateValue,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpportunityCriterias);
